import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import NavbarSection from "../components/NavbarSection";
import FooterSection from "../components/FooterSection";
import QRCode from "../assets/qr-code.png";
// import QRCode from "../assets/qr-code-2.png";
import AppStore from "../assets/appstore.png";
import PlayStore from "../assets/playstore.png";

const Download = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Immediate device detection and redirect
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    
    // Store URLs
    const iosUrl = "https://apps.apple.com/us/app/writeoffgenie/id6751060559";
    const androidUrl = "https://play.google.com/store/apps/details?id=com.writeoffgenie.app&pcampaignid=web_share";
    
    // Check for Android devices
    if (/android/i.test(ua)) {
      setIsMobile(true);
      // Use href for immediate redirect
      window.location.href = androidUrl;
      return;
    }
    
    // Check for iOS devices (iPhone, iPad, iPod)
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      setIsMobile(true);
      // Use href for immediate redirect
      window.location.href = iosUrl;
      return;
    }
  }, []);

  // Show loading state for mobile while redirecting
  if (isMobile) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f0f0f0",
        padding: "20px",
        textAlign: "center"
      }}>
        <div style={{
          fontSize: "1.5rem",
          fontWeight: "600",
          color: "#1a1a2e",
          marginBottom: "1rem"
        }}>
          Redirecting to the app store...
        </div>
        <div style={{
          fontSize: "1rem",
          color: "#666",
          marginBottom: "2rem"
        }}>
          If nothing happens, click below:
        </div>
        <div style={{
          display: "flex",
          gap: "1rem",
          justifyContent: "center",
          flexWrap: "wrap"
        }}>
          <a
            href="https://apps.apple.com/us/app/writeoffgenie/id6751060559"
            style={{
              padding: "12px 24px",
              backgroundColor: "#1a1a2e",
              color: "white",
              textDecoration: "none",
              borderRadius: "8px",
              fontSize: "1rem"
            }}
          >
            App Store
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.writeoffgenie.app&pcampaignid=web_share"
            style={{
              padding: "12px 24px",
              backgroundColor: "#1a1a2e",
              color: "white",
              textDecoration: "none",
              borderRadius: "8px",
              fontSize: "1rem"
            }}
          >
            Google Play
          </a>
        </div>
      </div>
    );
  }

  // Desktop view - show full page
  return (
    <>
      {/* Navbar without vector background */}
      <div style={{ 
        backgroundColor: "#f0f0f0",
        paddingBottom: "20px" 
      }}>
        <NavbarSection />
      </div>

      {/* Download Section */}
      <div style={{ 
        backgroundColor: "#f0f0f0", 
        minHeight: "100vh",
        padding: "80px 0"
      }}>
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Row>
              {/* Left Column - QR Code and Buttons */}
              <Col lg={6} md={12}>
                <div className="text-center">
                  {/* QR Code */}
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="mb-4"
                  >
                    <img
                      src={QRCode}
                      alt="Download QR Code"
                      style={{
                        width: "100%",
                        maxWidth: "300px",
                        height: "auto",
                        borderRadius: "12px"
                      }}
                    />
                    <p className="mt-3" style={{ 
                      fontSize: "0.9rem", 
                      color: "#666"
                    }}>
                      Scan to download the app
                    </p>
                  </motion.div>

                  {/* Store Buttons */}
                  <div className="d-flex flex-column align-items-center gap-3 mt-4" style={{ maxWidth: "280px", margin: "0 auto" }}>
                    <motion.a
                      href="https://apps.apple.com/us/app/writeoffgenie/id6751060559"
                      target="_blank"
                      rel="noopener noreferrer"
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.97 }}
                      style={{ 
                        textDecoration: "none",
                        width: "100%"
                      }}
                    >
                      <img
                        src={AppStore}
                        alt="Download on App Store"
                        style={{
                          width: "100%",
                          height: "auto",
                          cursor: "pointer",
                          borderRadius: "8px"
                        }}
                      />
                    </motion.a>

                    <motion.a
                      href="https://play.google.com/store/apps/details?id=com.writeoffgenie.app&pcampaignid=web_share"
                      target="_blank"
                      rel="noopener noreferrer"
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.97 }}
                      style={{ 
                        textDecoration: "none",
                        width: "100%"
                      }}
                    >
                      <img
                        src={PlayStore}
                        alt="Get it on Google Play"
                        style={{
                          width: "100%",
                          height: "auto",
                          cursor: "pointer",
                          borderRadius: "8px"
                        }}
                      />
                    </motion.a>
                  </div>
                </div>
              </Col>

              {/* Right Column - Content */}
              <Col lg={6} md={12} className="ps-lg-5">
                <motion.div
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  className="mt-5 mt-lg-0"
                >
                  <h1 style={{ 
                    fontSize: "3.5rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem",
                    lineHeight: "1.2"
                  }}>
                    Download
                  </h1>
                  
                  <p style={{ 
                    fontSize: "1.05rem", 
                    color: "#4a4a4a",
                    lineHeight: "1.7",
                    marginBottom: "2.5rem"
                  }}>
                    Get started with smart tax deductions on your mobile device. 
                    Snap receipts, track expenses, and maximize your deductions with AI-powered automation.
                  </p>

                  {/* Features list */}
                  <div style={{ 
                    fontSize: "1rem", 
                    color: "#4a4a4a",
                    lineHeight: "1.8"
                  }}>
                    <p className="mb-2">✓ Automatic receipt scanning</p>
                    <p className="mb-2">✓ Real-time expense tracking</p>
                    <p className="mb-2">✓ Smart categorization</p>
                    <p className="mb-2">✓ Tax deduction optimization</p>
                    <p className="mb-0">✓ Secure & IRS-compliant</p>
                  </div>
                </motion.div>
              </Col>
            </Row>
          </motion.div>
        </Container>
      </div>

      <FooterSection />
    </>
  );
};

export default Download;